import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Sohail</span>{" "}
            from <span className="purple">Pakistan, Living in Riyadh, Saudi Arabia</span>.
            <br />
            I’m currently working as a{" "}
            <span className="purple">Document Controller</span> and{" "}
            <span className="purple">Data Analyst</span>.
            <br />
            <br />
            <br />
            Outside of working as a Document Controller, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to do things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Sohail</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
